import appendQueryParams from "@/utils/appendQueryParams";
import { QueryFunctionContext } from "@tanstack/react-query";
import client from "../client";

/**
 * Get CTV channels with optional filtering
 */
export function findChannels(data: QueryFunctionContext) {
  return client.get(
    appendQueryParams("/ctv/channels", data?.meta?.queryParams ?? {})
  );
}